import { connect } from 'react-redux'
import * as selector from '../../state/detail/selector'
import PaymentList from '../../../payment/component/list/PaymentList'


const mapStateToProps = (state, props) => {
    return {
        paymentList: selector.selectPaymentList(state),
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentList)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/PaymentListWidgetContainer.js